import * as req from 'api/actions';
import * as c from './constants';

export const dummy = () => {};

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    '/api/v1/administrators/reports/transaction_histories',
    payload,
    callback
  );

export const generateReports = (payload = {}, callback) =>
  req.list(
    c.GENERATE_COMPUTER_FEE,
    '/api/v1/administrators/reports/export_computer_fee',
    payload,
    callback
  );

export const generateAuditLogReports = (payload = {}, callback) =>
  req.list(
    c.GENERATE_AUDIT_LOG,
    '/api/v1/administrators/general/export_audits',
    payload,
    callback
  );

export const getComputerFeeList = (payload = {}, callback) => {
  const params = { ...payload };

  if (params.type === 'GENERAL') {
    delete params.type;
  }

  return req.list(
    c.COMPUTER_FEE_LIST,
    '/api/v1/administrators/report_file_exports',
    params,
    callback
  );
};

export const upload = (payload = {}, callback) =>
  req.upload(
    c.UPLOAD,
    '/api/v1/administrators/rpt_billing_imports/upload_csv',
    payload,
    callback
  );

export const generateAgencyReports = (payload = {}, callback) =>
  req.create(
    c.GENERATE_AGENCY_REPORT,
    '/api/v1/administrators/general_reports/generate',
    payload,
    callback
  );

export const getAgencyReportList = (payload = {}, callback) =>
  req.list(
    c.AGENCY_REPORT_LIST,
    '/api/v1/administrators/general_reports',
    payload,
    callback
  );

export const getReportFilter = (payload = {}, callback) =>
  req.list(
    c.REPORT_FILTER,
    '/api/v1/administrators/general_reports/filters',
    payload,
    callback
  );

// TODO: Update endpoint (Waiting for BE's endpoint)
export const getReportTypes = (payload = {}, callback) =>
  req.list(
    c.REPORT_TYPES,
    '/api/v1/administrators/general_reports/types',
    payload,
    callback
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    c.GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );